/** The 300–600ms beat between the question landing and the answer arriving. */
export function TypingIndicator() {
  return (
    <div className="flex items-center gap-2.5">
      <span
        role="status"
        aria-label="Ask DVA is typing"
        className="flex items-center gap-[5px] rounded-[12px_12px_12px_4px] border border-[#e5e7eb] bg-white px-4 py-3.5"
      >
        <span className="block size-1.5 rounded-full bg-dvaNavy animate-[dvaHelpDot_1.25s_ease-in-out_infinite]" />
        <span className="block size-1.5 rounded-full bg-dvaNavy animate-[dvaHelpDot_1.25s_ease-in-out_0.16s_infinite]" />
        <span className="block size-1.5 rounded-full bg-dvaNavy animate-[dvaHelpDot_1.25s_ease-in-out_0.32s_infinite]" />
      </span>
    </div>
  );
}
